import { PaginatedQuery, ProjectIntegrationDto, SortDirections, SorterDescriptor } from "app/ApiClient";
import { projectIntegrationsTableConfig } from "const/projectIntegrations";
import { LoadingState } from "types";

export interface PaginatedDtoOfProjectIntegration {
  pageData?: ProjectIntegration[] | undefined;
  totalCount?: number;
  pageNumber?: number;
  pageSize?: number;
}

export interface ProjectIntegration extends ProjectIntegrationDto {
  encodedVersionDate?: string;
}

export interface ProjectIntegrations extends PaginatedDtoOfProjectIntegration {
  allData: ProjectIntegration[];
  pageData: ProjectIntegration[];
}

export interface PageContextOfProjectIntegrationFilter {
  page?: PaginatedQuery | undefined;
  sortList?: SorterDescriptor[] | undefined;
}

export const initialPageContext: PageContextOfProjectIntegrationFilter = {
  page: {
    pageNumber: projectIntegrationsTableConfig.DefaultPageNumber,
    pageSize: projectIntegrationsTableConfig.DefaultPageSize,
  },
  sortList: [{ directions: SortDirections.Desceding, field: "modifiedAt" }],
};


export interface ProjectIntegrationMessage {
  id: string;
  status: LoadingState,
  message: string;
  platformLink?:string
  platformLinkText?:string
}
export type ProjectIntegrationsState = {
  loading: LoadingState;
  integrations: ProjectIntegrations;
  createPoweBIIntLoadingStatus: LoadingState;
  createForstaVizIntLoadingStatus: LoadingState;
  createAscribeLoadingStatus: LoadingState;
  createWalrIntegrationLoadingStatus: LoadingState; 
  pushForstaIntegrationLoadingStatus: LoadingState;  
  pushForstaIntegrationId?: number;
  downloadPowerBiFileStatus: {
    [key: string]: LoadingState
  };
  alertMessages : Array<ProjectIntegrationMessage>
  pageContext: PageContextOfProjectIntegrationFilter;
  filters?: { [key in keyof ProjectIntegration]: string[] };
};

export const initialProjectIntegrationsState: ProjectIntegrationsState = {
  loading: LoadingState.idle,
  integrations: {
    allData: [],
    pageData: [],
  },
  createPoweBIIntLoadingStatus: LoadingState.idle,
  createForstaVizIntLoadingStatus: LoadingState.idle,
  createAscribeLoadingStatus: LoadingState.idle,
  createWalrIntegrationLoadingStatus: LoadingState.idle,
  pushForstaIntegrationLoadingStatus: LoadingState.idle,  
  downloadPowerBiFileStatus: {},
  alertMessages:[],
  pageContext: initialPageContext,
};
